module.exports = __webpack_public_path__ + "static/media/metrocorp-white.0fdcfcd7.svg";